import { Component, Input } from '@angular/core';
import { texts } from './list-projects.texts';

@Component({
  standalone: false,
  selector: 'app-list-projects',
  templateUrl: './list-projects.component.html',
  styleUrls: ['./list-projects.component.scss']
})
export class ListProjectsComponent {

  @Input()
  projects : any = [];

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

}
